
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flag-be': {
    width: 640,
    height: 480,
    viewBox: '0 0 640 480',
    data: '<g fill-rule="evenodd" stroke-width="1pt"><path pid="0" d="M0 0h213.3v480H0z"/><path pid="1" _fill="#ffd90c" d="M213.3 0h213.4v480H213.3z"/><path pid="2" _fill="#f31830" d="M426.7 0H640v480H426.7z"/></g>'
  }
})
